import * as React from 'react';

export default function MarketingVisual(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={70} height={70} viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M45.781 42.492a7.967 7.967 0 000-15.916M45.889 54.977l-35.69-15.362V29.362L45.89 14v40.977zM10.199 39.615H7.127A5.127 5.127 0 012 34.488v0a5.127 5.127 0 015.127-5.127h3.072"
        stroke="var(--cds-color-grey-700)"
        strokeWidth={3}
        strokeLinejoin="round"
      />
      <path
        d="M33.188 48.778l-1.41 3.573a4.11 4.11 0 01-5.36 2.358l-9.574-3.68a4.11 4.11 0 01-2.358-5.359l1.483-3.822M59.679 28.666a10.27 10.27 0 012.072 6.216 10.45 10.45 0 01-1.786 5.806M64.84 24.432a17.076 17.076 0 01.18 20.667"
        stroke="var(--cds-color-grey-700)"
        strokeWidth={3}
        strokeLinejoin="round"
      />
    </svg>
  );
}
